import { TransactionAmount, UserInfo } from 'client/Interfaces/Banking/BankTransactionsState'

import { PeriodPickerValue } from '../../components/common/PeriodPicker/PeriodPicker'

export type RedirectUrl = 'banking' | 'expenses'

export interface BalanceAmount {
  amount: string
  currency: string
}

export interface BankAccount {
  id: string
  currency: string
  accountHolderType: string
  nameClient: string
  accountType: string
  name: string
  active: boolean
  balance?: BalanceAmount
}

export interface BankLogo {
  binaryContent: string
  fileType: string
  logoUrl: string
}

export interface Bank {
  id: string
  name: string
  country: string
  showContactBankInfo: boolean
  logo?: BankLogo | string
  accounts?: BankAccount[]
  psuTypes?: string[]
  activeAccounts?: number
  unmatchedTransactions?: number
  unmatchedFaceValue?: number
  currency?: string
}

export interface BankingConsentReqBody {
  authorization: string
  bankId: string
}

export interface BankingConsentRequest {
  consentCodeBody: BankingConsentReqBody
  selectedBankingProvider: string
}

export interface AccountsUpdateReqBody {
  bankId: string
  activeAccounts: string[]
}

export interface AccountsUpdateRequest {
  accountsUpdateBody: AccountsUpdateReqBody
  selectedBankingProvider: string
}

export interface BankTransactionRequest {
  datePeriod: PeriodPickerValue
  selectedBankingProvider: string
}

export interface MatchInvoiceReqBody {
  invoiceId: number
  transactionId: string
  transactionInfo: TransactionInfoData
}

export interface MatchInvoiceRequest {
  matchInvoiceReqBody: MatchInvoiceReqBody
  selectedBankingProvider: string
}

export interface UnMatchInvoiceReqBody {
  invoiceId: number
  transactionId: string
}

export interface UnMatchInvoiceRequest {
  unMatchInvoiceReqBody: UnMatchInvoiceReqBody
  selectedBankingProvider: string
}

export interface TransactionViewOptionRequest {
  selectedBankingProvider: string
  transactionId: string
  excluded: boolean
}

export interface TransactionsFilterPeriodRequest {
  transactionsFilterPeriod: string
}

export interface BankingUrlRequest {
  bankId?: string
  bankName?: string
  country?: string
  psuType?: string
  redirectUrl?: RedirectUrl
}

export interface TransactionInfoData {
  creditor?: UserInfo
  transactionDate: string
  bookingDate: string
  transactionAmount: TransactionAmount
  referenceNumber?: string
  additionalInfo?: string
}
